import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: max-content;
  padding: 4px 0;
  position: relative;

  input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  label,
  a {
    font-size: 20px;
    font-weight: 300;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 16px;
    }
  }

  a {
    text-decoration: underline;
    z-index: 1;

    &:hover {
      transition: 0.7s;
      color: ${({ theme }) => theme.colors.primary.light};
    }
  }
`;

export const Boll = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.grey.white};
  border-radius: 4px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 16px;
    height: 16px;
  }

  img {
    width: 72%;
    opacity: 0;
  }

  ${({ $check }) =>
    $check &&
    css`
      background-color: ${({ theme }) => theme.colors.primary.main};

      img {
        opacity: 1;
      }
    `}
`;

export const Error = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;

  svg {
    width: 20px;
    color: ${({ theme }) => theme.colors.outher.danger};
  }

  span {
    color: ${({ theme }) => theme.colors.outher.danger};
    margin-bottom: -2px;
  }
`;
